import {
  Paper,
  Stack,
  Tabs,
  Tab,
  Box,
  Divider,
  Typography,
  useTheme,
  Button,
  TextField,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";

import { memo, useEffect, useState, useMemo, useCallback } from "react";

import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Dangerous,
  Error,
  FilterListOff,
  KeyboardBackspace,
  LocalFireDepartment,
  ReportProblem,
  Undo,
} from "@mui/icons-material";

import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { useMapa } from "../../../contexts/mapaContext";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/pt-br";
import { ptBR } from "@mui/x-date-pickers/locales";
import VirtualizedAlerts from "./cardAlerts/virtualizacao";
import VirtualizedHosts from "./cardHosts/virtualizacao";
import VirtualizedMaps from "./cardMaps/virtualizacao";
import TimeFilter from "./timeFilter";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

dayjs.locale("pt-br");
const CardNoMaps = memo(({ theme }) => (
  <Paper
    elevation={0}
    sx={{
      background: theme.palette.background.paperSelectedMaps,
      height: "30px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Typography
      sx={{ fontSize: "0.875rem", color: theme.palette.color.text }}
      color={theme.palette.mode === "dark" ? "#ffffff6e" : ""}
    >
      Não há mapas
    </Typography>
  </Paper>
));

function SliderBarMaps({
  iconsElements,
  setFocusNodeId = () => {},
  collapse,
  handleCollapse,
  fullscreen = false,
  isPublic,
}) {
  const { mapRef, elements, alertsDataMap } = useMapa();
  const theme = useTheme();
  const navigate = useNavigate();
  const [alertasTotais, setAlertasTotais] = useState([]);
  const [mapasConectados, setMapasConectados] = useState([]);
  const [hosts, setHosts] = useState([]);

  const [filterHosts, setFilterHosts] = useState("");
  const [filterAlerts, setFilterAlerts] = useState(0);
  const [filterMaps, setFilterMaps] = useState("");
  const [valueTab, setValueTab] = useState(2);

  const [dataInicial, setDataInicial] = useState(null);
  const [dataFinal, setDataFinal] = useState(null);
  const [anchorElDate, setAnchorElDate] = useState(null);

  // estilos memoizados
  const styles = useMemo(
    () => ({
      textAdorment: {
        ml: "-5px",
        fontSize: "12px",
        fontWeight: 800,
        color: theme.palette.color.bgIcon,
      },
      data: {
        overflow: "auto",
        height: "100%",
        width: "100%",
      },
      container: {
        width: collapse ? "0px" : "340px",
        position: "absolute",
        zIndex: 1200,
        transition: "width 0.3s ease",
        backgroundColor: theme.palette.background.default,
        borderRight: collapse
          ? "none"
          : "1px solid" + theme.palette.color.appBarBorder,
        height: "calc(100vh - 65px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      },
      menuButton: {
        position: "absolute",
        top: { xs: 2.5, sm: 7 },
        left: 3,
        zIndex: 1200,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "50px",
        height: "50px",
      },
      content: {
        flex: 1,
        overflow: "hidden",
        opacity: collapse ? 0 : 1,
        visibility: collapse ? "hidden" : "visible",
        transition: "opacity 0.3s ease, visibility 0.3s ease",
        padding: collapse ? 0 : "0px 10px",
      },
      card: {
        borderRadius: "5px",
        backgroundColor: theme.palette.background.paperSelectedMaps,
        boxShadow: "0px 0px 3px #0000001a",
        border: "none",
        "&::before": { display: "none" },
      },
      tabs: {
        "& button": {
          color: theme.palette.text.disabled,
          textTransform: "none",
          minHeight: "20px",
          Height: "100%",
          borderRadius: "5px",
          paddingX: "10px",
        },
        "& .MuiTab-icon": { marginRight: "2px" },
        "& button.Mui-selected": {
          backgroundColor: theme.palette.background.tab,
        },
        "& .MuiTabs-indicator": {
          backgroundColor: "transparent",
          border: "none",
        },
      },
      buttonReturn: {
        mt: 2,
        backgroundColor: theme.palette.background.paperSelectedMaps,
        color: theme.palette.text.disabled,
        textTransform: "none",
        boxShadow: "0px 0px 3px #0000001a",
        "&:hover": {
          backgroundColor: theme.palette.background.hover,
          boxShadow: "0px 0px 3px #0000001a",
          color: theme.palette.primary.main,
        },
      },
      text: { fontSize: "0.875rem", color: theme.palette.color.text },
      textCount: {
        fontSize: "0.8rem",
        textAlign: "start",
        p: "5px 10px",
        mt: "5px",
        color: theme.palette.text.disabled,
        backgroundColor: theme.palette.background.paperSelectedMaps,
        //mb: "10px",
      },
    }),
    [theme, collapse],
  );

  // otimizar separação de elementos
  useEffect(() => {
    const elementsMap = [...elements?.values()];
    const alertas = [];
    const mapas = [];
    const hostsTemp = [];

    for (const ele of elementsMap) {
      const alerts = alertsDataMap?.get(ele.id);
      if (alerts?.length) alertas.push(...alerts);
      if (ele?.tipo === 0) hostsTemp.push(ele);
      else if (ele?.tipo === 1 || ele?.tipo === 2) mapas.push(ele);
    }
    setAlertasTotais(alertas);
    setMapasConectados(mapas);
    setHosts(hostsTemp);
  }, [elements, alertsDataMap]);

  // funções estáveis
  const handleChange = useCallback((_, newValue) => setValueTab(newValue), []);
  const search = useCallback(
    (id) => {
      setFocusNodeId(id);
      mapRef?.current?.focusZoomExt(id);
    },
    [setFocusNodeId, mapRef],
  );

  // listas filtradas com useMemo
  const filteredMaps = useMemo(
    () =>
      mapasConectados.filter((m) =>
        m?.titulo?.toLowerCase()?.includes(filterMaps?.toLowerCase()),
      ),
    [mapasConectados, filterMaps],
  );

  const filteredHosts = useMemo(
    () =>
      hosts.filter((h) =>
        h?.titulo?.toLowerCase()?.includes(filterHosts?.toLowerCase()),
      ),
    [hosts, filterHosts],
  );

  const filteredAlerts = useMemo(
    () =>
      alertasTotais.filter((alert) => {
        const date = dayjs(alert.lastchange * 1000).second(0);

        const matchesSeverity =
          filterAlerts == 0 || alert.severity == filterAlerts;

        const matchesDateStart =
          !dataInicial || date.isSameOrAfter(dataInicial);

        const matchesDateEnd = !dataFinal || date.isSameOrBefore(dataFinal);

        return matchesSeverity && matchesDateStart && matchesDateEnd;
      }),
    [alertasTotais, filterAlerts, dataInicial, dataFinal],
  );
  const CountList = ({ list }) => {
    return (
      <Typography sx={styles.textCount}>
        {(list.length || 0) + " itens encontrados"}
      </Typography>
    );
  };
  return (
    <>
      {!fullscreen && (
        <Box sx={styles.menuButton}>
          <IconButton onClick={handleCollapse} sx={{ p: 0.5 }}>
            <MenuIcon />
          </IconButton>
        </Box>
      )}

      <Box sx={styles.container}>
        <Box sx={styles.content}>
          {/* conteúdo do sidebar */}
          <Stack direction="column" gap={2} height="100%">
            {!isPublic && (
              <Button
                onClick={() => navigate(-1)}
                startIcon={<KeyboardBackspace />}
                sx={styles.buttonReturn}
                variant="contained"
              >
                Voltar
              </Button>
            )}
            <Stack
              sx={[
                styles.card,
                { p: 0.5, mt: isPublic ? 2 : 0, height: "50px" },
              ]}
            >
              <Tabs
                variant="fullWidth"
                value={valueTab}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                sx={styles.tabs}
              >
                <Tab
                  sx={[
                    styles.text,
                    { "& .MuiTab-icon": { marginRight: "1px" } },
                  ]}
                  icon={valueTab == 2 ? <BoltOutlinedIcon /> : null}
                  label="Alertas"
                  value={2}
                  iconPosition={"start"}
                />{" "}
                <Tab
                  icon={valueTab == 1 ? <MapOutlinedIcon /> : null}
                  label="Mapas"
                  value={1}
                  sx={styles.text}
                  iconPosition={"start"}
                />{" "}
                <Tab
                  sx={styles.text}
                  icon={valueTab == 3 ? <StorageOutlinedIcon /> : null}
                  label="Hosts"
                  value={3}
                  iconPosition={"start"}
                />{" "}
              </Tabs>
            </Stack>

            <Stack gap={2} sx={{ overflow: "hidden", height: "100%" }}>
              {valueTab === 1 && (
                <>
                  <TextField
                    placeholder="Busca"
                    size="small"
                    value={filterMaps}
                    onChange={(e) => setFilterMaps(e.target.value)}
                    slotProps={{ input: { endAdornment: <SearchIcon /> } }}
                  />
                  {filteredMaps.length === 0 ? (
                    <CardNoMaps theme={theme} />
                  ) : (
                    <Stack sx={styles.data} gap={1}>
                      <VirtualizedMaps
                        maps={filteredMaps}
                        alertsDataMap={alertsDataMap}
                        style={styles.data}
                        search={search}
                      />
                      <CountList list={filteredMaps} />
                    </Stack>
                  )}
                </>
              )}

              {valueTab === 2 && (
                <>
                  <TextField
                    select
                    size="small"
                    value={filterAlerts}
                    onChange={(e) => setFilterAlerts(e.target.value)}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              ALERT
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                    }}
                  >
                    <MenuItem value={0}>
                      <FilterListOff sx={{ mr: 1 }} /> Todos
                    </MenuItem>
                    <Divider />
                    <MenuItem value={5}>
                      <LocalFireDepartment sx={{ mr: 1 }} /> Desastre
                    </MenuItem>
                    <MenuItem value={4}>
                      <Dangerous sx={{ mr: 1 }} /> Alto impacto
                    </MenuItem>
                    <MenuItem value={3}>
                      <Error sx={{ mr: 1 }} /> Moderado
                    </MenuItem>
                    <MenuItem value={2}>
                      <ReportProblem sx={{ mr: 1 }} /> Alerta
                    </MenuItem>
                  </TextField>

                  {/* <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="pt-br"
                    localeText={
                      ptBR.components.MuiLocalizationProvider.defaultProps
                        .localeText
                    }
                  >
                    <DateTimePicker
                      label={!dataInicial ? "Data inicial" : null}
                      value={dataInicial}
                      maxDate={dayjs()}
                      onChange={setDataInicial}
                      slotProps={{
                        textField: { size: "small" },
                        actionBar: { actions: ["clear", "accept"] },
                      }}
                    />
                    <DateTimePicker
                      label="Data Final"
                      value={dataFinal}
                      maxDate={dayjs()}
                      minDate={dataInicial}
                      onChange={setDataFinal}
                      slotProps={{
                        textField: { size: "small" },
                        actionBar: { actions: ["today", "clear", "accept"] },
                      }}
                    />
                  </LocalizationProvider> */}
                  <TimeFilter
                    key={"TimeFilter"}
                    anchorElDate={anchorElDate}
                    setAnchorElDate={setAnchorElDate}
                    initialDate={dataInicial}
                    finalDate={dataFinal}
                    onTimeChange={({ initial, final }) => {
                      setDataInicial(initial);
                      setDataFinal(final);
                    }}
                  />

                  <Stack gap={1} sx={styles.data}>
                    <VirtualizedAlerts
                      alertasTotais={filteredAlerts}
                      style={styles.data}
                      search={search}
                    />
                    <CountList list={filteredAlerts} />
                  </Stack>
                </>
              )}

              {valueTab === 3 && (
                <>
                  <TextField
                    placeholder="Busca"
                    size="small"
                    value={filterHosts}
                    onChange={(e) => setFilterHosts(e.target.value)}
                    slotProps={{ input: { endAdornment: <SearchIcon /> } }}
                  />
                  <Stack gap={1} sx={styles.data}>
                    <VirtualizedHosts
                      hosts={filteredHosts}
                      style={styles.data}
                      search={search}
                      iconsElement={iconsElements}
                    />
                    <CountList list={filteredHosts} />
                  </Stack>
                </>
              )}
            </Stack>
          </Stack>
        </Box>
      </Box>
    </>
  );
}

export default memo(SliderBarMaps);
